module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.recipes', {
            url: '/cocktail-recipes',
            data: {
                analytics: 'bws:web:cocktail recipes'
            },
            resolve: {
                deps: ['$$animateJs', '$ocLazyLoad', function ($$animateJs, $ocLazyLoad) {
                    console.log($$animateJs);
                    return $ocLazyLoad.load(window.wowModules[5].files[0]);
                }]
            },
            parent: 'root',
            views: {
                'dynamic-content-top@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule class="dynamic-content2-panelTop"></oly-dynamic-content>'
                },
                'dynamic-content-bottom@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule="bottom" class="dynamic-content2-panelBottom"></oly-dynamic-content>'
                },
                'aem-view@': {
                    template: '<wow-aem-portal project="generic" is-partial="true"></wow-aem-portal>'
                }
            }
        })
        .state('shop.recipes.category', {
            url: '/:category',
            views: {
                'center-panel@': {
                    template: '<wow-recipe-list></wow-recipe-list>'
                }
            },
            data: {
                analytics: [
                    '$state', function ($state) {
                        return `bws:web:cocktail recipes:${$state.params.category}`;
                    }
                ],
                shouldGetMetadata: false
            },
            params: {
                sortby: null
            }
        })
        .state('shop.recipes.category.page', {
            url: '/:id',
            data: {
                analytics: [
                    '$state', function ($state) {
                        return `bws:web:cocktail recipes:${$state.params.category}:${$state.params.id}`;
                    }
                ],
                shouldGetMetadata: false
            },
            views: {
                'center-panel@': {
                    template: '<wow-recipes></wow-recipes>'
                }
            }
        });
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/routes/recipes.js
 **/